/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import { Dimensions } from 'react-native';
import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import Modal from '@components/modal/Modal';
import { PortalHost } from '@gorhom/portal';

const dimension = Dimensions.get('window');

const ModalSearch = (props) => {
  const insets = useSafeAreaInsets();
  const searchHeight = isWeb
    ? dimension.height - 150
    : dimension.height - insets.top - insets.bottom - 55;

  const onClose = () => {
    try {
      props.onClose();
    } catch (error) {}
  };

  return (
    <Modal
      animationType="slide"
      fullPage={true}
      visible={props.visible}
      onClose={() => onClose()}>
      <SafeAreaView style={{ flex: 0, backgroundColor: Colors.blue1 }} />
      <SafeAreaView
        style={[
          { flex: 1, backgroundColor: 'transparent' },
          { maxHeight: searchHeight },
          isWeb && !isMobileWeb ? { borderRadius: 5, overflow: 'hidden' } : {},
        ]}>
        {props.children}
      </SafeAreaView>
      <PortalHost name="modal-sticky-button" />
    </Modal>
  );
};

export default React.memo(ModalSearch, (prev, next) => prev == next);
